import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState as r, useEffect as o } from "react";
import { env as t } from '../utils/env.js';

function l() {
  var _r = r(t.isHandoffComplete),
      _r2 = _slicedToArray(_r, 2),
      e = _r2[0],
      f = _r2[1];

  return e && t.isHandoffComplete === !1 && f(!1), o(function () {
    e !== !0 && f(!0);
  }, [e]), o(function () {
    return t.handoff();
  }, []), e;
}

export { l as useServerHandoffComplete };